module.exports = __webpack_public_path__ + "img/print-logo.fb486c87.jpg";